$('body').on('click', '.add-seat-trigger', function() {
    openModal('.add-seat');
    return false;
});

$("body").on("click", ".open-seat-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".seat-menu-wrapper");

    $(".seat-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".seat-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".seat-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-seat-trigger', function() {
    var data = $(this).parents('.seat');
    var action = $('.edit-seat form').attr('data-action').replace('{seat}', data.attr('data-seat'));
    $('.edit-seat form').attr('action', action);


    $('.edit-seat [name="seat_number"]').val(data.attr('data-seat_number'));
    $('.edit-seat [name="old_number"]').val(data.attr('data-old_number'));
    $('.edit-seat [name="name"]').val(data.attr('data-name'));
    $('.edit-seat [name="hebrew_name"]').val(data.attr('data-hebrew_name'));
    $('.edit-seat [name="notes"]').val(data.attr('data-notes'));

    openModal('.edit-seat');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-seat form, .edit-seat form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-seat', function(data) {
    // console.log(data);
    var element;

    if($('.seat[data-seat="'+data.seat+'"]').length) {
        element = $('.seat[data-seat="'+data.seat+'"]');

        element.attr('data-seat_number', data.seat_number);
        element.attr('data-old_number', data.old_number);
        element.attr('data-name', data.name);
        element.attr('data-hebrew_name', data.hebrew_name);
        element.attr('data-notes', data.notes);

        element.find('[data-input="seat_number"]').html(data.seat_number);
        element.find('[data-input="old_number"]').html(data.old_number);
        element.find('[data-input="name"]').html(data.name);
        element.find('[data-input="hebrew_name"]').html(data.hebrew_name);
        element.find('[data-input="total_payments"]').html(data.total_payments);
        element.find('[data-input="total_paid_parsed"]').html(data.total_paid_parsed);
        element.find('[data-input="total_upcoming_payments"]').html(data.total_upcoming_payments);
        element.find('[data-input="total_upcoming_paid_parsed"]').html(data.total_upcoming_paid_parsed);
        element.find('[data-input="notes"]').html(data.notes);

        element.find('.seat-menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'seat',
            'data-seat': data.seat,
            'data-seat_number': data.seat_number,
            'data-old_number': data.old_number,
            'data-name': data.name,
            'data-hebrew_name': data.hebrew_name,
            'data-notes': data.notes
        });

        element.append(`<td>
            <p data-input="seat_number">${data.seat_number}</p>
            <p class="small-text" data-input="old_number">${data.old_number}</p>
        </td>    

        <td>
            <p data-input="name">${data.name}</p>
            <p class="small-text" data-input="hebrew_name">${data.hebrew_name}</p>
        </td>

        <td>
            (<span data-input="total_payments">${data.total_payments}</span>)
            <span data-input="total_paid_parsed">${data.total_paid_parsed}</span>
        </td>
        
        <td>
            (<span data-input="total_upcoming_payments">${data.total_upcoming_payments}</span>)
            <span data-input="total_upcoming_paid_parsed">${data.total_upcoming_paid_parsed}</span>
        </td>

        <td>
            <p class="small-text" data-input="notes">${data.notes}</p>
        </td>
        <td class="seat-menu-wrapper menu-wrapper" data-dropdown="seat-${data.seat}">
            <a href="" class="icon-more open-seat-menu open-menu"></a>
            <ul class="seat-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.seats tbody').prepend(element);
    }
});